export default __webpack_public_path__ + "static/tel_icon-4c9d18f5edc86750d4291035fec13692.png";